import { useMemo } from 'react';
import { useGetGridColumnsQuery } from '@/store/gridColumnsApi';
import type { GridKey } from '@/constants/gridKeys';

// Centralized grid columns hook: filters out the 'Details' column for all grids.
// `skip` defers the request, which callers that mount before authentication need:
// the query argument does not change when the token arrives, so a 401 answered
// early stays in the cache until a refetch or a remount.
export const useGridColumns = (
  gridKey: GridKey,
  options?: { skip?: boolean },
) => {
  const query = useGetGridColumnsQuery(
    { gridKey },
    { skip: options?.skip ?? false },
  );

  const filteredData = useMemo(() => {
    const data = query.data;
    if (!data?.Records) return data;
    const records = data.Records.filter((r) => {
      const field = (r.GridColumnDataField || '').toLowerCase();
      return field !== 'details' && field !== 'deteails';
    });
    if (records.length === data.Records.length) return data;
    return { ...data, Records: records };
  }, [query.data]);

  return { ...query, data: filteredData } as typeof query;
};
